export default {
  data() {
    return {
      x: 0,
      y: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll(e) {
      this.x = window.top.scrollX;
      this.y = window.top.scrollY;
      /* or: e.target.documentElement.scrollTop */
    },
  },
  computed: {
    scrollY() {
      return this.y;
    },
    scrollX() {
      return this.x;
    },
  },
};